class MrHideCredits extends HTMLElement {
	#clickHandler = (): void => {
		const forEl = this.getForEl();
		if ( !forEl ) {
			return;
		}

		if ( !forEl.hasAttribute( 'show-credits' ) ) {
			return;
		}

		forEl.removeAttribute( 'show-credits' );

		const content: HTMLElement | null = forEl.querySelector( '.song-player-info__content' );

		if ( content && matchMedia( '(min-width: 768px) and (max-width: 1023px)' ).matches ) {
			content.style.transform = 'translateY(0)';
		}
	};

	connectedCallback() {
		this.addEventListener( 'click', this.#clickHandler );
	}

	disconnectedCallback() {
		this.removeEventListener( 'click', this.#clickHandler );
	}

	getForEl(): HTMLElement|null {
		const forElVideoId = this.getAttribute( 'for' );
		if ( !forElVideoId ) {
			return null;
		}

		return document.querySelector( `mr-video-player[video-id="${forElVideoId}"` );
	}
}

customElements.define( 'mr-hide-credits', MrHideCredits );
